import React from 'react';
import {connect} from 'react-redux';
import ReactJsonViewer from 'react-json-view';

import Logger, {LOG_LEVELS} from '../../../utils/logger';

const log = new Logger('AVA_JSON_TREEVIEW', LOG_LEVELS.DEBUG);

export class avaJsonTreeview extends React.Component {

  render() {
    log.debug('render(): ', this.props);

    // Disable the inline edit if onEdit is undefined or if disabled prop is true
    const editHandler = (this.props.disabled || !this.props.onEdit) ? undefined : this.props.onEdit;

    return (
      <ReactJsonViewer
        src={this.props.src}
        name={this.props.name}
        indentWidth={this.props.indent}
        enableClipboard={this.props.enableClipboard}
        collapsed={this.props.collapsed}
        displayDataTypes={this.props.displayDataTypes}
        displayObjectSize={this.props.displayObjectSize}
        iconStyle={this.props.iconStyle}
        style={this.props.style}
        theme={this.props.theme}
        onEdit={editHandler}
      />
    );
  }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages
  };
}


avaJsonTreeview.defaultProps = {
  name: 'ReportingDocument',
  indent: 6,
  enableClipboard: false,
  collapsed: false,
  displayDataTypes: false,
  displayObjectSize: false,
  iconStyle: 'circle',
  style: {
    padding: "10px",
    borderRadius: "3px",
    margin: "10px 0px",
    fontFamily: '"source-sans-pro", "Open Sans", "Helvetica Neue", "Helvetica", Helvetica, Arial, san-serif',
    fontSize: "14px"
  },
  theme: 'shapeshifter:inverted'
};

export default connect(mapStateToProps)(avaJsonTreeview);